import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export const STALE_RANGE_LABEL_KEYS = {
  1: 'StaleRange1To2',
  2: 'StaleRange2To3',
  3: 'StaleRange3To6',
  6: 'StaleRange6To12',
  12: 'StaleRangeOver12',
};

export const STALE_RANGE_SHORT_LABEL_KEYS = {
  1: 'StaleRange1To2Short',
  2: 'StaleRange2To3Short',
  3: 'StaleRange3To6Short',
  6: 'StaleRange6To12Short',
  12: 'StaleRangeOver12Short',
};

function getRangeLabel(bucketMonths, keys) {
  const labelKey = keys[bucketMonths];
  return labelKey ? Trans(translations, labelKey) : String(bucketMonths);
}

function withTokkoBrokerHost(url) {
  if (!url) return url;

  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  return `${tokkoBrokerHost}${url}`;
}

export function buildStaleRecordsChartData(
  bucketsResponse,
  datasetLabelKey,
  backgroundColor
) {
  const buckets = bucketsResponse?.buckets ?? [];

  const labels = buckets.map((bucket) => ({
    months: bucket.months,
    name: getRangeLabel(bucket.months, STALE_RANGE_LABEL_KEYS),
    axisLabel: getRangeLabel(bucket.months, STALE_RANGE_SHORT_LABEL_KEYS),
    count: bucket.disjoint_count,
    url: withTokkoBrokerHost(bucket.disjoint_url),
  }));

  const datasets = [
    {
      label: Trans(translations, datasetLabelKey),
      data: buckets.map((bucket) => bucket.disjoint_count),
      backgroundColor,
    },
  ];

  return {
    totalCount: buckets[0]?.count ?? 0,
    headerUrl: withTokkoBrokerHost(buckets[0]?.url) ?? null,
    labels,
    datasets,
  };
}
